import * as React from "react";
import { Divider, SkeletonLoader, Stack } from "@bookingcom/bui-react";
import Frame from "../../../../components/elements/Frame/index.js";
export const SkeletonFareRow = () => {
    const SkeletonRow = ({ compact = false }) => {
        const columnWidth = compact ? "105px" : "150px";
        return (React.createElement(Stack, { direction: "row", alignItems: "center", gap: 4, justifyContent: "space-between" },
            React.createElement(Stack.Item, { shrink: false, attributes: { style: { flexBasis: columnWidth } } },
                React.createElement(SkeletonLoader, { variant: "one-line" })),
            React.createElement(Stack.Item, { shrink: false, attributes: { style: { flexBasis: columnWidth } } },
                React.createElement(SkeletonLoader, { variant: "one-line" })),
            React.createElement(Stack.Item, { shrink: false, attributes: { style: { flexBasis: "50px" } } },
                React.createElement(SkeletonLoader, { variant: "one-line" }))));
    };
    return (React.createElement(Frame, { m: 3 },
        React.createElement(Stack, { gap: 3 },
            React.createElement(SkeletonRow, { compact: true }),
            React.createElement(Divider, null),
            React.createElement(SkeletonRow, null))));
};
